import React from "react";
import DarkInput from "../../../common/DarkInput";
import IconButtonCTA from "../../../common/IconButtonCTA";
import { SSave, SClose } from "../../../../styles/StyledMUI";
import type { QualificationDraft } from "../../../../api/qualification/Qualification.typed";

export type QualificationCreateRowProps = {
  draft: QualificationDraft;
  loading: boolean;
  onDraftChange: (patch: Partial<QualificationDraft>) => void;
  onSave: () => void;
  onCancel: () => void;
};

export default function QualificationCreateRow({
  draft,
  loading,
  onDraftChange,
  onSave,
  onCancel,
}: QualificationCreateRowProps) {
  return (
    <tr>
      <td>
        <DarkInput
          value={draft.sigle}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onDraftChange({ sigle: e.target.value })
          }
          size="sm"
          placeholder="Ex. PADI OW"
        />
      </td>
      <td>
        <DarkInput
          value={draft.name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onDraftChange({ name: e.target.value })
          }
          size="sm"
          placeholder="Nom"
        />
      </td>
      <td>
        <DarkInput
          value={draft.description}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onDraftChange({ description: e.target.value })
          }
          size="sm"
          placeholder="Description"
        />
      </td>
      <td>
        <IconButtonCTA
          aria-label="Enregistrer"
          ctaVariant="success"
          onClick={onSave}
          disabled={loading || !draft.sigle.trim()}
          sx={{ mr: 1 }}
        >
          <SSave />
        </IconButtonCTA>
        <IconButtonCTA
          aria-label="Annuler"
          ctaVariant="neutral"
          onClick={onCancel}
          disabled={loading}
        >
          <SClose />
        </IconButtonCTA>
      </td>
    </tr>
  );
}
